import { View } from "binder"
import { FormBuilderComponentView } from "src/formBuilder/structure/element";
import { InputElement } from "./input-viewModel"

export class InputView extends FormBuilderComponentView<InputElement>{
    GetViewUniqueId(): string {
        return "V-F28CF694-34DF-478D-AD18-20C4F6AB140C"
    }
    loadHtml(): string {
        let element = require('./input.html').default;
        let style = require('./input.less');
        return element;
    }
    constructor() {
       super();
    }

    public set Text(v: string) { this._Text = v; } public get Text(): string { return this._Text;} private _Text: string;
    public set ReadOnly(v: boolean) { this._ReadOnly = v; } public get ReadOnly(): boolean { return this._ReadOnly;} private _ReadOnly: boolean;
    public set IsNumeric(v: boolean) { this._IsNumeric = v; } public get IsNumeric(): boolean { return this._IsNumeric;} private _IsNumeric: boolean;
    public set IsPassword(v: boolean) { this._IsPassword = v; } public get IsPassword(): boolean { return this._IsPassword;} private _IsPassword: boolean;
    public set MaxLength(v: number) { this._MaxLength = v; } public get MaxLength(): number { return this._MaxLength;} private _MaxLength: number;
        
}
